import { withEvents } from '../../../mixins';

class Store {
    constructor({ dispatcher }) {
        if (!dispatcher) {
            throw new Error('dispatcher must be provided');
        }

        this._dispatcher = dispatcher;
        this._dispatchToken = this._dispatcher.register(this.onDispatch, this);
    }

    getDispatchToken() {
        return this._dispatchToken;
    }

    waitFor(dispatchToken) {
        this._dispatcher.waitFor(dispatchToken);
    }

    onDispatch() {
        throw new Error('onDispatch must be implemented');
    }

    destroy() {
        this._dispatcher.unregister(this._dispatchToken);
        this.stopListening();
    }
}

export default withEvents(Store);
